// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__DZ94u","colMaxWidth":"Table_colMaxWidth__w1OpF"};